import { Collapse } from "@mui/material";
import CheckBox from "../input/CheckBox";
import styles from "./m3.module.css";

/**
 * "Global View" checkbox for a grid footer (pass it to AgGrid's footerLeftContent).
 */
export const GlobalViewToggle = ({ checked, onChange, label = "Global View" }) => (
  <CheckBox checked={checked} onChange={(e) => onChange(e.target.checked)} label={label} />
);

/**
 * Collapsible analytics area shown below a grid when Global View is on.
 * Children stay mounted while collapsed so charts keep their state.
 *
 * @param {boolean} open
 */
const GlobalViewSection = ({ open, children }) => (
  <Collapse in={open} timeout="auto">
    <div className={styles.globalView}>{children}</div>
  </Collapse>
);

export default GlobalViewSection;
